module.exports = __webpack_public_path__ + "static/img/btn2.6b90907.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd118/btn2.gif
// module id = CfJR
// module chunks = 1